// extracted by mini-css-extract-plugin
export var userPageHeader = "user-page-header_bNorsXcMJVjnb5X24QmL";
export var userPageHeaderId = "user-page-header__id_esh8pZS678xcOB1A00AQ";